import { startCase } from "lodash-es";

/**
 * Some state fields (notably RCRA waste fields) arrive with their raw camelCase
 * key as the label, e.g. "rcraHasEnvironmentalManagementSystem". Turn those into
 * readable text; fields that already carry a human label are left untouched.
 *
 * Shared between the editable state-fields form and the frozen submission
 * snapshot, which only persists field keys (no labels) and so humanizes the key
 * directly.
 */
export function humanizeStateFieldLabel(label: string | null | undefined, key: string): string {
  const trimmed = label?.trim();
  if (trimmed && trimmed !== key) {
    return trimmed;
  }
  const withoutProgramPrefix = key.replace(/^(rcra|epcra)/i, "");
  return startCase(withoutProgramPrefix || key);
}
